export type ArtifactMenuPosition = {
    top: number
    left: number
}

export type OrdinalPlayableMediaKind = 'audio' | 'video'

export function ordinalMediaKey(
    kind: OrdinalPlayableMediaKind,
    {
        bsvOrdinalId,
        outpoint,
        src,
    }: {
        bsvOrdinalId?: string | null
        outpoint?: string | null
        src?: string | null
    },
): string | null {
    const identity = bsvOrdinalId
        ? `id:${bsvOrdinalId}`
        : outpoint
        ? `outpoint:${outpoint}`
        : src
        ? `src:${src}`
        : null

    return identity ? `ordinal-${kind}:${identity}` : null
}

export function ordinalPlaylistMediaKey({
    contentType,
    bsvOrdinalId,
    outpoint,
    src,
}: {
    contentType?: string | null
    bsvOrdinalId?: string | null
    outpoint?: string | null
    src?: string | null
}): string | null {
    const normalizedContentType = (contentType || '').toLowerCase()
    const kind: OrdinalPlayableMediaKind | null = normalizedContentType.startsWith('audio/')
        ? 'audio'
        : normalizedContentType.startsWith('video/')
        ? 'video'
        : null

    return kind ? ordinalMediaKey(kind, { bsvOrdinalId, outpoint, src }) : null
}

export function artifactMenuPosition({
    triggerTop,
    triggerBottom,
    triggerRight,
    menuWidth,
    menuHeight,
    viewportWidth,
    viewportHeight,
    padding = 8,
    gap = 4,
}: {
    triggerTop: number
    triggerBottom: number
    triggerRight: number
    menuWidth: number
    menuHeight: number
    viewportWidth: number
    viewportHeight: number
    padding?: number
    gap?: number
}): ArtifactMenuPosition {
    const maxLeft = Math.max(padding, viewportWidth - menuWidth - padding)
    const left = Math.min(Math.max(padding, triggerRight - menuWidth), maxLeft)
    const below = triggerBottom + gap
    const top =
        below + menuHeight <= viewportHeight - padding
            ? below
            : Math.max(padding, triggerTop - gap - menuHeight)

    return { top, left }
}
